module.exports = __webpack_public_path__ + "static/media/dinosaur(12).4a06bcf8.PNG";